<div [class]="'badge badge--' + badgeColor()">
  <ng-content select="[slot=badge]" />
</div>

<div class="text">
  <div class="title">
    <ng-content select="[slot=title]" />
  </div>
  <div class="description">
    <ng-content select="[slot=description]" />
  </div>
  <ng-content />
</div>
